<template>
  <div class="el-material-catalog">
    <el-button
      style="position:absolute;"
      plain
      type="single-number"
      @click="showDialog = true"
    >
      物装目录目录
    </el-button>
    <el-advanced-selector
      :query-search="querySearch"
      :handle-node-click="handleNodeClick"
      :props="props"
      :default-expanded-keys="defaultExpandedKeys"
      v-on:listenTochildEvent="showMessageFromChild"
      v-on:setSelectedNode="setSelectedNode"
      v-on:handleSelect="handleSelect2"
      @scrollBottom="handleScrollBottom"
      :load-node="loadNode"
      :isShowCol="true"
      :show-checkbox="showCheckbox"
      :dialogVisible.sync="showDialog"
      :tableData.sync="tempData"
      :totalSelectData.sync="totalSelectData"
    >
      <div slot="table" class="dialog__table">
        <el-table
          :border="true"
          :data="tableDate"
          ref="multiTable"
          tooltip-effect="dark"
          style="width: 580px"
          @selection-change="handleSelectionChange"
          @select="handleSelect"
          @select-all="handleSelectAll"
        >
          <el-table-column type="index" width="80" label="序号" align="center">
            <template slot-scope="scope"
              ><span
                >{{ scope.$index + (pageNo - 1) * pageSize + 1 }}
              </span></template
            >
          </el-table-column>

          <el-table-column
            prop="categoryCode"
            label="类别编码"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="categoryName"
            label="类别名称"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="ordercodeParent"
            label="级别code父类"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="isLeaf"
            label="是否末级"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="categoryLevel"
            label="级次"
            width="120"
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>
    </el-advanced-selector>
  </div>
</template>

<script>
import {
  searchmatCaterySingleLeftTreeRightTableTree,
  searchmatCaterySingleLeftTreeRightTableList
} from "../../api/";
export default {
  name: "ElMaterialCatalog",
  computed: {
    total() {
      return this.tempData.length;
    }
  },
  watch: {},
  data() {
    return {
      showDialog: this.dialogVisible,
      showCheckbox: true,
      tempData: [],
      tableDate: [],
      start: 0,
      end: 2,
      pageSize: 2,
      pageNo: 1,
      selectData: [], // 保存表格选中的数据
      totalSelectData: {},
      params: {},
      count: 1,
      dialogVisible: false,
      defaultExpandedKeys: [1],
      props: {
        label: "categoryName",
        children: "zones",
        isLeaf: "isLeaf"
      }
    };
  },
  props: {},
  mounted() {},
  methods: {
    searchmatCaterySingleLeftTreeRightTableTree() {
      let data = {
        categoryCode: "0"
      };
      searchmatCaterySingleLeftTreeRightTableTree(data).then(res => {});
    },
    arrUnique(arr, type) {
      const cus_tempArr = [];
      arr.map((v, i) => {
        if (cus_tempArr.length === 0) {
          cus_tempArr.push(v);
        } else {
          let isAdd = true;
          cus_tempArr.forEach((v1, i1) => {
            if (v[type] === v1[type]) {
              isAdd = false;
            }
          });
          if (isAdd) cus_tempArr.push(v);
        }
      });
      return cus_tempArr;
    },
    showMessageFromChild(data) {
      alert(JSON.stringify(data));
      this.$emit("handleTrue", data);
    },
    setSelectedNode(data) {
      let obj = [];
      obj.push(data);
      this.tableDate = obj;
    },
    handleSelect2(data) {
      this.tableDate = [];
      this.tableDate.push(data);
    },
    handleSelect(value, row) {
      this.selectData = [];
      if (value.length) {
        value.forEach((item, index) => {
          if (!this.selectData.includes(item)) {
            this.selectData.push(item);
            this.selectData = this.arrUnique(this.selectData, "id");
          }
        });
      }
      this.totalSelectData[this.pageNo] = this.selectData;
    },
    handleSelectAll(value) {
      this.selectData = [];
      if (value.length) {
        value.forEach((item, index) => {
          if (!this.selectData.includes(item)) {
            this.selectData.push(item);
            this.selectData = this.arrUnique(this.selectData, "id");
          }
        });
      }
      // if (this.selectData.length) {
      this.totalSelectData[this.pageNo] = this.selectData;
      // };
    },
    handleSelectionChange(value) {
      if (Object.keys(this.totalSelectData).length) {
        if (this.totalSelectData[this.pageNo]) {
          for (
            let i = 0, len = this.totalSelectData[this.pageNo].length;
            i < len;
            i++
          ) {
            this.$refs.multiTable.toggleRowSelection(
              this.totalSelectData[this.pageNo][i],
              true
            );
          }
        }
      }
    },
    handleSizeChange(val) {},
    handleCurrentChange(val) {
      if (this.totalSelectData[this.pageNo]) {
        for (
          let i = 0, len = this.totalSelectData[this.pageNo].length;
          i < len;
          i++
        ) {
          this.$refs.multiTable.toggleRowSelection(
            this.totalSelectData[this.pageNo][i],
            true
          );
        }
      }
    },
    handleNodeClick(data) {},
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    handleScrollBottom(data, callback) {
      this.params.pageNo++;
      searchmatCaterySingleLeftTreeRightTableList(this.params)
        .then(res => {
          let data = res.data.data.rows;
          data.map(item => {
            item.value = item.categoryName;
            item.address = item.fullPath;
          });
          callback(data);
        })
        .catch(e => {});
    },
    querySearch(queryString, cb) {
      this.params.categoryName = queryString;
      this.params.pageNo = 1;
      searchmatCaterySingleLeftTreeRightTableList(this.params)
        .then(res => {
          let data = res.data.data.rows;
          data.map(item => {
            item.value = item.categoryName;
            item.address = item.fullPath;
          });
          cb(data);
        })
        .catch(e => {});
    },
    loadNode(node, resolve) {
      if (node.level === 0) {
        let data = {
          categoryCode: "0"
        };
        searchmatCaterySingleLeftTreeRightTableTree(data).then(res => {
          return resolve(res.data.data.categoryList);
        });
      }
      if (node.level > 0) {
        let data = {
          categoryCode: node.data.categoryCode
        };
        searchmatCaterySingleLeftTreeRightTableTree(data).then(res => {
          res.data.data.categoryList.map(item => {
            item.isLeaf = item.isLeaf === 1;
            item.id = item.categoryCode;
          });
          return resolve(res.data.data.categoryList);
        });
      }
    }
  },
  updated() {}
};
</script>
